import React, {useEffect, useMemo, useState} from "react";
import {IContasContabeisFiltroDto} from "@models/contaContabil/createContaContabilDto.ts";
import {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {ButtonGroup, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {
    GetContaContabilLimitesRecurso,
    GetContasContabeis,
} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {ContaContabilInfoProps, ContaContabilInfoRow,} from "@components/contaContabil/ContaContabilInformacao.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {Publish} from "@mui/icons-material";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {ImportContasContabeisComponent} from "@components/contaContabil/ImportContasContabeisComponent.tsx";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";

interface ContasContabeisPageProps extends DefaultPageProps {
    slotProps?: {
        ContaContabilItem?: Partial<ContaContabilInfoProps>;
    },
    searchType?: 'Conta' | 'LimitesRecurso',
    filtros?: IContasContabeisFiltroDto,
}

export function ContasContabeisPage(props: ContasContabeisPageProps) {
    const {Get} = useApi();
    const {slotProps, filtros, pageProps} = props
    const {ContaContabilItem} = slotProps || {};
    const {addPopUp} = useAlert()
    const EndComponent = ContaContabilItem?.EndComponent || undefined;


    const [contasContabeis, setContasContabeis] = useState<IContaContabil[]>([]);
    const [pagination, setPagination] = useState<IPagination>(pageProps?.pagination ?? {page: 1, pageSize: 10});

    useEffect(() => {
        setPagination({...pagination, page: 0});

    }, [filtros]);

    useEffect(() => {
        if (pageProps) {
            setPagination(pageProps.pagination);
        }
    }, [pageProps?.pagination]);


    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination(prev => prev.page !== 1 ? {...prev, page: 1} : prev);
            return;
        }
        setPagination(prev => ({...prev, loading: true}));

        Get(props.searchType == 'Conta' && GetContasContabeis({...props.filtros}, pagination) ||
            GetContaContabilLimitesRecurso({
                recursoId: ((filtros?.idRecurso && filtros.idRecurso[0]) ?? 0),
                contaContabilId: ((filtros?.idContaContabil && filtros.idContaContabil[0]) ?? 0),
                search: filtros?.search,
            }, pagination)).then(x => {
            if (x.status == 'Success') {
                setContasContabeis(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
            }
        }).finally(() => {
            setPagination(prev => ({...prev, ignoreCache: false, loading: false}))
        });

        pageProps?.setPagination({...pagination})

    }, [pagination.page, pagination.ignoreCache == true]);

    const tableBody = useMemo(() => {
        return (<TableBody>
            {contasContabeis.map(((conta, i) => {
                return (
                    <ContaContabilInfoRow value={conta}
                                          key={i}
                                          EndComponent={EndComponent}
                    />
                )
            }))}
        </TableBody>)
    }, [contasContabeis]);


    return (
        <DefaultContainer size={'large'}
                          titulo={props.hideHeader ? '' : "Contas Contábeis"}
                          UpperComponent={<Grid container spacing={1} size={12}>
                              <Grid size={{xs: 12, md: 6}}>

                              </Grid>
                              <Grid size={{xs: 12, md: 6}} component={ButtonGroup} fullWidth>
                                  <PermissionableButton permission={['CriarContaContabil']}>Criar</PermissionableButton>
                                  <PermissionableButton permission={['CriarContaContabil']} icon={<Publish/>}
                                                        onClick={() => {
                                                            addPopUp({
                                                                title: 'Importar contas contabeis',
                                                                content: <ImportContasContabeisComponent
                                                                    onCreate={() => {
                                                                        setPagination(prev => ({
                                                                            ...prev,
                                                                            ignoreCache: true
                                                                        }))
                                                                    }}/>,
                                                                size: 'lg'
                                                            })
                                                        }}>Importar</PermissionableButton>
                              </Grid>
                          </Grid>}
                          pageProps={{pagination, setPagination}}>
            <Grid px={1}>
                <Grid container>
                    <Grid size={12}>
                        <TableContainer>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Nome</TableCell>
                                        <TableCell>Codigo</TableCell>
                                        <TableCell align={'right'}>Mais</TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableBody}
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>

        </DefaultContainer>
    );
}